import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParceiroAuth } from '../../contexts/ParceiroAuthContext';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Loader2, Handshake } from 'lucide-react';
import { toast } from 'sonner';

export default function ParceiroLogin() {
  const { login } = useParceiroAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email.trim(), senha.trim());
      if (data.user?.senha_temporaria) {
        toast.info('Por segurança, altere sua senha temporária.');
        navigate('/parceiro/perfil?trocar_senha=1');
      } else {
        navigate('/parceiro/dashboard');
      }
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Não foi possível entrar. Verifique seus dados.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#3D4F5F] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl p-7">
        <div className="flex flex-col items-center mb-6">
          <img src="/logo-full.png" alt="Tenance" className="h-11 mb-3" />
          <div className="flex items-center gap-2 text-[#2B7A3D] font-semibold text-sm">
            <Handshake size={18} /> Portal do Parceiro
          </div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="pemail">E-mail</Label>
            <Input id="pemail" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@email.com" data-testid="parceiro-login-email" />
          </div>
          <div>
            <Label htmlFor="psenha">Senha</Label>
            <Input id="psenha" type="password" required value={senha} onChange={(e) => setSenha(e.target.value)} placeholder="••••••••" data-testid="parceiro-login-senha" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#2B7A3D] hover:bg-[#236632] h-11 text-base" data-testid="parceiro-login-submit">
            {loading ? <Loader2 className="animate-spin" size={18} /> : 'Entrar'}
          </Button>
        </form>
        <p className="text-xs text-gray-500 text-center mt-5">
          Esqueceu a senha? Fale com a Tenance para gerar uma senha temporária.
        </p>
        <p className="text-xs text-gray-400 text-center mt-2">
          Quer ser parceiro? Entre em contato: <a className="text-[#2B7A3D] font-medium" href="https://www.tenance.com.br" target="_blank" rel="noreferrer">tenance.com.br</a>
        </p>
      </div>
    </div>
  );
}
